<div class="ddc-quiz-list">
  <!-- Loading state -->
  <div class="loading-container" *ngIf="loading()">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading quizzes...</p>
  </div>

  <!-- Quiz list -->
  <div class="quiz-grid" *ngIf="!loading()">
    <div class="quiz-card" *ngFor="let quiz of quizzes()" (click)="onQuizCardClick(quiz.id)">
      <!-- Quiz header with owner info -->
      <div class="quiz-header">
        <ddc-profile-pic
          [dynamicRoute]="'/users/' + quiz.owner?.username"
          [followerCount]="quiz.owner?.followers_count"
          [minimal]="true"
          [subscription]="quiz.owner?.subscription"
          [username]="quiz.owner?.username"
          [userProfilePic]="quiz.owner?.profile_pic"
        ></ddc-profile-pic>

        <div class="quiz-header-info">
          <ddc-text-gradient [_icon]="'question_answer'" [_text]="'Quiz'" [_type]="'1'"> </ddc-text-gradient>
          <ddc-privacy [code]="quiz.privacy" [withText]="false"></ddc-privacy>
        </div>
      </div>

      <!-- Quiz title and description -->
      <div class="quiz-content">
        <h3 class="quiz-title">{{ quiz.title }}</h3>
        <p class="quiz-description" *ngIf="quiz.description">
          {{ quiz.description | slice: 0 : 100 }}{{ quiz.description.length > 100 ? '...' : '' }}
        </p>

        <!-- Quiz stats -->
        <div class="quiz-stats">
          <span class="stat-item" *ngIf="quiz.questions_count">
            <mat-icon>quiz</mat-icon>
            {{ quiz.questions_count }} questions
          </span>
          <span class="stat-item" *ngIf="quiz.notes && quiz.notes.length">
            <mat-icon>note</mat-icon>
            {{ quiz.notes.length }} notes
          </span>
          <span class="stat-item" *ngIf="quiz.likes">
            <mat-icon>favorite</mat-icon>
            {{ quiz.likes }}
          </span>
          <span class="stat-item" *ngIf="quiz.bookmarks">
            <mat-icon>bookmark</mat-icon>
            {{ quiz.bookmarks }}
          </span>
        </div>

        <!-- Quiz metadata -->
        <div class="quiz-meta">
          <span class="meta-item" *ngIf="quiz.time_since_creation">
            <mat-icon>schedule</mat-icon>
            {{ quiz.time_since_creation }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div class="empty-state" *ngIf="!loading() && quizzes().length === 0">
    <mat-icon>quiz</mat-icon>
    <p>No quizzes available</p>
  </div>

  <!-- Loading more indicator -->
  <div class="loading-more" *ngIf="loadingMore()">
    <mat-spinner diameter="30"></mat-spinner>
    <p>Loading more quizzes...</p>
  </div>
</div>
